import Instances from './Instances';

export default Instances;